import { array, bool, func, string } from 'prop-types'
import { Button, PopoverV2 } from '@opallabs/kuiper'
import { track } from '@opallabs/quanta'
import { isInWorkflowPopover } from '../../../helpers/matchers'
import {
  approvalOptionsContent,
  approvalOptionsTrigger,
  getApprovalButtonHash,
  sendForApproval,
} from './helpers'
import './styles.scss'

const onClickSend = (status, workflowLocation, callback) => {
  const event = status === 'denied' ? 'Approvals: Resend' : 'Approvals: Send'
  track(event, {
    workflowPopover: isInWorkflowPopover(workflowLocation),
  })
  callback()
}

const ApprovalButton = ({
  approvals,
  isLimitedRole,
  phaseItems,
  requiresAllApprovals,
  shouldDisplayOptions,
  shouldRender,
  status,
  update,
  workflowLocation,
}) => {
  if (!shouldRender) {
    return null
  }

  const approvalButtonHash = getApprovalButtonHash(
    approvals,
    requiresAllApprovals,
    status
  )
  const boundOnClickSend = onClickSend.bind(this, status, workflowLocation)

  if (shouldDisplayOptions) {
    return (
      <PopoverV2
        className="resendApprovalOptions"
        content={approvalOptionsContent(boundOnClickSend, phaseItems, update)}
        trigger={approvalOptionsTrigger(approvalButtonHash)}
      />
    )
  }

  return (
    <Button
      className={approvalButtonHash.className}
      color={approvalButtonHash.color}
      disabled={approvalButtonHash.disabled || isLimitedRole}
      label={approvalButtonHash.label}
      onClick={sendForApproval.bind(
        this,
        boundOnClickSend,
        phaseItems,
        update,
        false
      )}
    />
  )
}

ApprovalButton.propTypes = {
  approvals: array,
  isLimitedRole: bool,
  phaseItems: array,
  requiresAllApprovals: bool,
  shouldDisplayOptions: bool,
  shouldRender: bool,
  status: string,
  update: func,
  workflowLocation: string,
}

export default ApprovalButton
